import React from 'react'
import { useState } from 'react';
import MasterLayout from  '../../Layouts/MasterLayout.jsx'
import styles from '../../Styles/MasterPage/MasterPage.module.css'
import Menu from  '../../Pages/Menu/Menu.jsx'

const Home = () => {

  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <div className={styles.homePage}> 
        <MasterLayout  menu={<Menu selectedItem={selectedItem}  setSelectedItem={setSelectedItem} />}/>
    </div>
  )
}

export default Home